import { format, parseISO } from "date-fns";
import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import ChartCard, { Legend } from "./ChartCard";
import ChartTooltip from "./ChartTooltip";
import { axisProps, chart, directionLabels, series } from "./theme";

const KEYS = ["inbound", "outbound", "internal"];

const shortDate = (d) => format(parseISO(d), "d MMM");

function CallVolumeChart({ daily, style }) {
  return (
    <ChartCard
      title="Call volume"
      subtitle="Recorded calls per day by direction"
      height={280}
      style={style}
      legend={
        <Legend
          items={KEYS.map((k) => ({
            label: directionLabels[k],
            color: series[k],
          }))}
        />
      }
      table={{
        columns: ["Date", "Inbound", "Outbound", "Internal"],
        rows: daily.map((d) => [
          shortDate(d.date),
          d.inbound,
          d.outbound,
          d.internal,
        ]),
      }}
    >
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart
          data={daily}
          margin={{ top: 4, right: 8, bottom: 0, left: -12 }}
        >
          <defs>
            {KEYS.map((k) => (
              <linearGradient
                key={k}
                id={`vol-${k}`}
                x1="0"
                y1="0"
                x2="0"
                y2="1"
              >
                <stop offset="0%" stopColor={series[k]} stopOpacity={0.45} />
                <stop offset="100%" stopColor={series[k]} stopOpacity={0.08} />
              </linearGradient>
            ))}
          </defs>
          <CartesianGrid vertical={false} stroke={chart.grid} />
          <XAxis
            dataKey="date"
            tickFormatter={shortDate}
            minTickGap={24}
            {...axisProps}
          />
          <YAxis allowDecimals={false} {...axisProps} axisLine={false} />
          <Tooltip
            cursor={{ stroke: chart.axis }}
            content={
              <ChartTooltip
                title={(label) => format(parseISO(label), "EEE d MMM")}
                rows={(payload) => [
                  ...[...payload].reverse().map((p) => ({
                    label: directionLabels[p.dataKey],
                    value: p.value,
                    color: series[p.dataKey],
                  })),
                  {
                    label: "Total",
                    value: payload.reduce((sum, p) => sum + p.value, 0),
                  },
                ]}
              />
            }
          />
          {KEYS.map((k) => (
            <Area
              key={k}
              type="monotone"
              dataKey={k}
              stackId="calls"
              stroke={series[k]}
              strokeWidth={2}
              fill={`url(#vol-${k})`}
              activeDot={{ r: 4, stroke: chart.surface, strokeWidth: 2 }}
            />
          ))}
        </AreaChart>
      </ResponsiveContainer>
    </ChartCard>
  );
}

export default CallVolumeChart;
